import { 
    gql, 
    useMutation 
} from "@apollo/client";
import React, { ReactElement } from "react";
import { CreateCommunityMutationMutation, CreateCommunityMutationMutationVariables } from "../../../../schemaTypes";

import { normalizeErrors } from "../../../../utils/normalizeErrors";
import { NormalizedErrorMap } from "../../../../types/NormalizedErrorMap";

export const createCommunityMutation = gql`
  mutation CreateCommunityMutation(
        $name: String!
        $alias: String!
        $logoUrl: String
        $colorCode: String
    ) {
        createCommunity(
            name: $name
            alias: $alias
            logoUrl: $logoUrl
            colorCode: $colorCode
            ) {
            errors {
                path
                message
            }
            message
        }
  }
`;

interface Props {
  children: (
    data: {
      submitCreateCommunity: (
        values: CreateCommunityMutationMutationVariables & {
          logoUrlFile?: File;
        }
      ) => Promise<NormalizedErrorMap | any>;
      loading: boolean;
      error: any;
      message: string | null;
      createCommunityData: any | null; 
    }
  ) => ReactElement | null;
}

function fileToBase64(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result as string);
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
}

export const CreateCommunityController: React.FC<Props> = ({ children }) => {
  const [mutate, { loading, error, data }] = useMutation<
    CreateCommunityMutationMutation,
    CreateCommunityMutationMutationVariables
  >(
    createCommunityMutation
  );

  const submitCreateCommunity = async (values: CreateCommunityMutationMutationVariables & { logoUrlFile?: File }) => {
    const { logoUrlFile, ...rest } = values;
    let logoUrlSrc = rest.logoUrl;
    if (logoUrlFile) {
     logoUrlSrc = await fileToBase64(logoUrlFile);
    }

    const { data: {createCommunity} }:any = await mutate({ 
      variables: {
        ...rest,
        logoUrl: logoUrlSrc
      }
    });

    if (createCommunity?.errors) {
      return {error: normalizeErrors(createCommunity.errors), createCommunity: null};
    }

    return {
      error: null,
      createCommunity
    };
  };

  const message = data?.createCommunity?.message || null;

  return children({
    submitCreateCommunity,
    loading,
    error,
    message,
    createCommunityData: data,
  });
};